<template>
  <div class="income-tax-calculator">
    <NavBar sticky>
      <template #left>
        <ButtonIconContextual
          label="Voltar para página anterior"
          size="small"
          icon="EF0030"
          @click="handleCloseButton"
        />
      </template>
    </NavBar>
    <main>
      <FadeTransition>
        <TaxCalculatorContent />
      </FadeTransition>
      <FadeTransition>
        <ButtonContainer class="income-tax-calculator__button-container">
          <template #button-primary>
            <ButtonPrimary
              size="large"
              label="Acessar plataforma IR Trade"
              @click="handleButtonAction"
            />
          </template>
        </ButtonContainer>
      </FadeTransition>
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import {
  ButtonContainer,
  ButtonPrimary,
  ButtonIconContextual,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { TaxCalculatorContent } from './components/TaxCalculatorContent';
import { FadeTransition } from '@/modules/common/components/FadeTransition';

import { data } from './data';

@Component({
  components: {
    ButtonContainer,
    ButtonPrimary,
    ButtonIconContextual,
    FadeTransition,
    NavBar,
    TaxCalculatorContent
  }
})
export default class IncomeTaxCalculator extends Vue {
  readonly data = data;

  get shouldGoBack() {
    return !!this.$route.query.goBack;
  }

  handleCloseButton() {
    this.shouldGoBack
      ? this.$router.back()
      : this.$router.replace({ name: 'home' });
  }

  async handleButtonAction() {
    window.open('https://irtrade.com.br/redirecting-warren', '_blank');
  }
}
</script>

<style lang="less" scoped>
.income-tax-calculator {
  position: relative;
  padding-bottom: @size-spacing-x1200;

  &__button-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: @background-secondary;
    z-index: 10;
  }
}
</style>
